import { useEffect } from 'react';

// Marks every [data-reveal] element with data-shown once it scrolls into view.
// The attribute is set directly on the node so React re-renders never clear it.
// Pass a key (e.g. the language) to pick up nodes that mount after a content change.
const useReveal = (key) => {
  useEffect(() => {
    const nodes = Array.from(document.querySelectorAll('[data-reveal]:not([data-shown])'));

    if (!('IntersectionObserver' in window)) {
      nodes.forEach((node) => node.setAttribute('data-shown', ''));
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.setAttribute('data-shown', '');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0 }
    );

    nodes.forEach((node) => observer.observe(node));
    return () => observer.disconnect();
  }, [key]);
};

export default useReveal;
